import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"outlined":""}},[_c(VDatePicker,{attrs:{"full-width":"","no-title":"","min":_vm.calendarMinSelectableDate,"max":_vm.calendarMaxSelectableDate,"allowed-dates":_vm.calendarAllowedDates},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }